import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  MapearErrosServidor,
  MapearErrosServidorCampo,
} from "src/hook/Functions";
import {
  getCstOptions,
  TributacaoCfopImpostoCadastroDto,
  TributacaoCfopImpostoCadastroSchema,
} from "./TributacaoCfopImpostoCadastro.Dto";
import {
  TributacaoCfopImpostoAlterar,
  TributacaoCfopImpostoBuscarId,
  TributacaoCfopImpostoIncluir,
} from "src/services/Fiscal.Service";
import { showToast } from "src/componentes";
import TributacaoCfopImpostoCadastroMenu from "./TributacaoCfopImpostoCadastro.Menu";

const TributacaoCfopImpostoCadastroCode = () => {
  const [loading, setLoading] = useState(true);
  const [incluir, setIncluir] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const tributacaoCfopId = searchParams.get("tributacaocfopid");
  const type = searchParams.get("type");
  const [selectedCSTValue, setSelectedCSTValue] = useState<number>(0);
  const menu = TributacaoCfopImpostoCadastroMenu({ id, setLoading });

  const form = useForm<TributacaoCfopImpostoCadastroDto>({
    resolver: yupResolver(TributacaoCfopImpostoCadastroSchema),
    defaultValues: {
      tributacaoCFOPId: Number(tributacaoCfopId),
      tipoImposto: Number(type),
    },
  });

  useEffect(() => {
    const controller = new AbortController();
    const Load = async () => {
      try {
        if (id) {
          setLoading(true);
          const response = await TributacaoCfopImpostoBuscarId(id);
          if (response.data.success) {
            const data = response.data.data as TributacaoCfopImpostoCadastroDto;
            form.reset(data);
            setIncluir(false);
            setSelectedCSTValue(data.cst);
          } else {
            showToast({
              message: "Ocorreu erro ao carregar TributacaoCfopImposto",
              title: "Erro",
              variant: "Danger",
            });
          }
        } else {
          setIncluir(true);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    Load();
    return () => {
      controller.abort();
    };
  }, [id]);

  const onSubmit = async (data: TributacaoCfopImpostoCadastroDto, e: any) => {
    e.preventDefault();
    setLoading(true);
    if (incluir === true) {
      TributacaoCfopImpostoIncluir(data)
        .then((response) => {
          if (response.data.success) {
            navigate(`/fiscal/tributacao/cfop/cadastro?id=${tributacaoCfopId}`);
          } else {
            MapearErrosServidorCampo(
              response.data.notifications,
              form.setError,
            );
            MapearErrosServidor(response.data.notifications, showToast);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      data.id = Number(id);
      TributacaoCfopImpostoAlterar(data)
        .then((response) => {
          if (response.data.success) {
            navigate(`/fiscal/tributacao/cfop/cadastro?id=${tributacaoCfopId}`);
          } else {
            MapearErrosServidorCampo(
              response.data.notifications,
              form.setError,
            );
            MapearErrosServidor(response.data.notifications, showToast);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return {
    loading,
    onSubmit,
    form,
    getCstOptions,
    selectedCSTValue,
    setSelectedCSTValue,
    menu,
    type,
  };
};
export default TributacaoCfopImpostoCadastroCode;
